import { render, staticRenderFns } from "./AdminPackingPrices.vue?vue&type=template&id=23787fb6&scoped=true"
import script from "./AdminPackingPrices.vue?vue&type=script&lang=js"
export * from "./AdminPackingPrices.vue?vue&type=script&lang=js"
import style0 from "./AdminPackingPrices.vue?vue&type=style&index=0&id=23787fb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23787fb6",
  null
  
)

export default component.exports